import React, { useEffect } from "react";
import { NotificationInterface } from "../../../../store/mine_craft/notificationsSlice";

import { Button, Collapse, Form, Input, Switch } from "antd";
import {CheckOutlined, ExclamationCircleOutlined} from "@ant-design/icons";
import { AVAILABLE_LOCALES } from "../../../../configs/constants";

const { Panel } = Collapse;

interface propsInterface {
  params: NotificationInterface;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();
  const locales: string[] = [...Object.keys(params.body_translations), ...params.empty_locales];

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  const renderLocaleTitle = (locale: string) => {
    const state = !!params.title_translations[locale] ||
      !!params.subtitle_translations[locale] ||
      !!params.body_translations[locale];

    if(state) {
      return(
        <>
          <CheckOutlined style={{ color: '#52c41a' }} /> {AVAILABLE_LOCALES[locale]} :{locale}
        </>
      )
    } else {
      return(
        <>
          <ExclamationCircleOutlined style={{ color: '#FBA018' }} /> {AVAILABLE_LOCALES[locale]} :{locale}
        </>
      )
    }
  }

  const renderTranslations = (locale: string) => {
    if (locale === 'en') {
      return undefined;
    }

    return(
      <div key={`notification-${locale}`} className='v-mb-30'>
        <h6 className='v-content-label o-sm'>{renderLocaleTitle(locale)}</h6>

        <Form.Item
          name={['title_translations', locale]}
          label='Title'
        >
          <Input placeholder={`Title`} />
        </Form.Item>

        <Form.Item
          name={['subtitle_translations', locale]}
          label='Subtitle'
        >
          <Input placeholder={`Subtitle`} />
        </Form.Item>

        <Form.Item
          name={['body_translations', locale]}
          label='Body'
        >
          <Input.TextArea rows={4} placeholder={`Body`}/>
        </Form.Item>
      </div>
    )
  }

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <Form.Item label="Active" name='active' valuePropName='checked'>
        <Switch
          checkedChildren='enabled'
          unCheckedChildren='disabled'
        />
      </Form.Item>

      <div className='v-mb-10'>
        <Form.Item name='title' label="Title">
          <Input />
        </Form.Item>

        <Form.Item name='subtitle' label="Subtitle">
          <Input />
        </Form.Item>

        <Form.Item name='body' label="Body">
          <Input.TextArea rows={4} />
        </Form.Item>
      </div>

      <Collapse ghost expandIconPosition='end'>
        <Panel header={null} key="1" extra={<>Translations</>}>
          { locales.map(renderTranslations) }
        </Panel>
      </Collapse>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
